<template>
  <div class="view pa24">
    <el-dialog :title="title" width="800px" :modal-append-to-body="false" :visible.sync="dialogVisible"
      :close-on-click-modal="false" :before-close="closeDialog">
      <el-form ref="dealerRuleForm" :model="ruleForm" :rules="rules" label-width="100px">
        <el-form-item label="采购计划单" prop="classIds">
          <el-select v-model="ruleForm.excleId" placeholder="请选择采购计划" @change="handleExcleId">
            <el-option v-for="item in ruleForm.classList" :key="item.id" :label="item.serial"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属公司" prop="company">
          <el-select v-model="ruleForm.companyName" placeholder="请选择公司">
            <el-option label="浙江利佳航空设备制造股份有限公司" value="浙江利佳航空设备制造股份有限公司"></el-option>
            <el-option label="利佳（上海）航空设备有限公司" value="利佳（上海）航空设备有限公司"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="零部件编号" prop="partNumber">
          <el-input v-model="ruleForm.partNumber" placeholder="请输入零部件编号"></el-input>
        </el-form-item>
        <el-form-item label="零部件名称" prop="partName">
          <el-input v-model="ruleForm.partName" placeholder="请输入零部件名称"></el-input>
        </el-form-item> -->
        <el-form-item label="序列号" prop="serialNumber">
          <el-input v-model="ruleForm.serialNumber" placeholder="请输入序列号"></el-input>
        </el-form-item>
        <!-- <el-form-item label="数量" prop="quantity">
          <el-input v-model="ruleForm.quantity" placeholder="请输入数量"></el-input>
        </el-form-item> -->
        <el-form-item label="合同号" prop="contractNumber">
          <el-input v-model="ruleForm.contractNumber" placeholder="请输入合同号"></el-input>
        </el-form-item>
        <el-form-item label="作业编号" prop="jobNumber">
          <el-input v-model="ruleForm.jobNumber" placeholder="请输入作业编号"></el-input>
        </el-form-item>
        <el-form-item label="计划下达日期" prop="plannedDate">
          <el-date-picker v-model="ruleForm.plannedDate" type="date" placeholder="选择计划下达日期" format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item label="要求完成日期" prop="requiredCompletionDate">
          <el-date-picker v-model="ruleForm.requiredCompletionDate" type="date" placeholder="选择要求完成日期"
            format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item label="编制人日期" prop="compiledBy">
          <el-input v-model="ruleForm.compiledBy" placeholder="请输入编制人及日期"></el-input>
        </el-form-item>
        <el-form-item label="审核人日期" prop="reviewedBy">
          <el-input v-model="ruleForm.reviewedBy" placeholder="请输入审核人及日期"></el-input>
        </el-form-item>
        <el-form-item label="批准人日期" prop="approvedBy">
          <el-input v-model="ruleForm.approvedBy" placeholder="请输入批准人及日期"></el-input>
        </el-form-item>
        <div class="dialog-footer" style="text-align: right;">
          <el-button @click="closeDialog">取 消</el-button>
          <el-button class="btncss" @click="confirmAddCustomer">生 成</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import { getPurchase, queryList, getExcleParam } from '@/api/boomClass.js'
  import { baseUrl } from "@/utils/index"

  export default {
    name: "addPageClass",
    components: {},
    props: [],
    data() {
      let token = localStorage.getItem("token")
      return {
        fileList: [],
        uploadUrl: this.$store.state.uploadingUrl,
        ossUrl: this.$store.state.ossUrl,
        upParams: {
          token: token
        },
        provinces: [],
        classType: null,
        dialogVisible: false,
        title: '',
        ruleForm: {
          partNumber: '',
          partName: '',
          quantity: '',
          contractNumber: '',
          jobNumber: '',
          requiredCompletionDate: '',
          compiledBy: '',
          reviewedBy: '',
          approvedBy: '',
          classIds: [],
          classList: []
        },
        rules: {},

      };
    },
    onShow() { },
    // mounted() {
    //   this.resetForm()
    // },
    methods: {
      handleExcleId(orderId) {
        let params = {
          orderId
        }
        getExcleParam(params).then(res => {
          let childData = res.data.excleDetails[0]
          this.ruleForm.partNumber = childData.partNumber
          this.ruleForm.partName = childData.name
          this.ruleForm.quantity = childData.quantities
          this.ruleForm.contractNumber = childData.contract
          this.ruleForm.jobNumber = childData.homeCode
          this.ruleForm.requiredCompletionDate = childData.delivery
          // this.ruleForm.compiledBy = res.data.prepared
          // this.ruleForm.reviewedBy = res.data.examined
          // this.ruleForm.approvedBy = res.data.approver
          this.$forceUpdate()
        })
      },
      async openDialog(dat) {
        // this.ruleForm={}
        this.dialogVisible = true
        this.title = '生成采购清单'
        this.resetForm()
      },
      resetForm() {
        let param = {
          excelType: 1
        }
        queryList(param).then(res => {
          this.ruleForm.classList = res.data.list
          console.log(this.ruleForm.classList);
        })
      },
      closeDialog() {
        this.dialogVisible = false
        this.ruleForm.partNumber = ""
        this.ruleForm.partName = ""
        this.ruleForm.quantity = ""
        this.ruleForm.contractNumber = ""
        this.ruleForm.jobNumber = ""
        this.ruleForm.requiredCompletionDate = ""
        this.ruleForm.compiledBy = ""
        this.ruleForm.reviewedBy = ""
        this.ruleForm.approvedBy = ""
        this.ruleForm.excleId = ""
        this.$forceUpdate()
      },
      confirmAddCustomer() {
        console.log(this.ruleForm);
        this.$refs.dealerRuleForm.validate((valid) => {
          if (valid) {
            getPurchase(this.ruleForm).then(res => {
              if (res.code === 200) {
                console.log(baseUrl);
                let urls = baseUrl + res.data
                console.log(urls);
                const link = document.createElement('a');
                link.href = urls;
                link.style.display = 'none';
                // 修改下载文件名为zip格式
                link.download = '采购清单.zip';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                this.$message({
                  type: 'success',
                  message: '导出成功'
                });
              }
            });
            this.$emit("getList");
            this.closeDialog();
          }
        });
      }
    }
  };
</script>
<style lang="scss" scoped>
  .component {
    margin-bottom: 10px;

    &.even {
      background-color: #f5f5f5;
    }

    &.odd {
      background-color: #fff;
    }
  }

  .accessory {
    margin-bottom: 10px;
    padding-left: 20px;

    &.even {
      background-color: #f5f5f5;
    }

    &.odd {
      background-color: #fff;
    }
  }

  .sub-accessory {
    margin-bottom: 10px;
    padding-left: 40px;

    &.even {
      background-color: #f5f5f5;
    }

    &.odd {
      background-color: #fff;
    }
  }
</style>